module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASCAYAAACw50UTAAABFklEQVQ4T9XTvS5EURTF8d8kKo03QEShEBEa0U1ovAbi4zU8hCEU3kIlEYKCSJBQCl5CfEW2nJucjJk7dzKmsNtzz1r7/Ne6NX2cWh+1/X/xIRxhGbc9orrAIbYKLFO4wQdmezB4wjCOUc+Zr2IPX5hJZlUfMYAHjOMZI3GxOdA17CaDOVxWUB/EGaZxh6DwM63asoEGPhEGVyUGIXySUIZBHe9l4nG2jp30gmKjZo9YLMKfTIyX8Jp/VNbzHFGrDB4xinMsNAu3w5Kbr2A/IQqDoqZFK+4T40D4a6r8oXmL5nGACYRBbN52qojnGRRC1ynE0jJVFQ+RTWzjFIt461TTbsRDawwved3+AkunJVued7t5VybfgJk2E/eGgvkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dropdown.png
// module id = OVVS
// module chunks = 2